<template>
    <!-- <LoaderComponent v-model:data="AppLoaderData" /> -->
    <div v-if="environment != 'PROD'">
        <div class="version-tag version-tag--beta">{{ `${environment} verzija` }}</div>
    </div>

    <ExportFactory />
    <MessageBox />
    <DocumentViewer />
    <router-view />
</template>

<script setup lang="ts">
    import { MessageBox } from "fw4-library";
    import { DocumentViewer } from "fw4-library";
    import { ExportFactory } from "fw4-library";

    const environment = import.meta.env.MODE;
</script>

<style lang="scss">
    .connection-tag {
        position: fixed;
        z-index: 9000;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        padding: 4px 15px;
        font-size: 13px;
        font-weight: 600;
        background-color: #fbeaeb;
        color: #db323b;
        border: 1px solid #db323b;
        border-top: 0;
        text-align: center;

    }

    .dots {
        display: inline-block;
        margin-left: 2px;
        width: 15px;
        aspect-ratio: 4.5;
        --_g: no-repeat radial-gradient(circle closest-side, #db323b 90%, #0000);
        background:
            var(--_g) 0% 50%,
            var(--_g) 50% 50%,
            var(--_g) 100% 50%;
        background-size: calc(100%/3) 100%;
        animation: l7 1.5s infinite linear;
    }

    @keyframes l7 {
        33% {
            background-size: calc(100%/3) 0%, calc(100%/3) 100%, calc(100%/3) 100%
        }

        50% {
            background-size: calc(100%/3) 100%, calc(100%/3) 0%, calc(100%/3) 100%
        }

        66% {
            background-size: calc(100%/3) 100%, calc(100%/3) 100%, calc(100%/3) 0%
        }
    }

</style>
